export const RootPrefix = 'stripe_elements';
